import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { CircularProgress } from '@rmwc/circular-progress';
import '@rmwc/circular-progress/styles';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import * as calcs from './TableCalcs';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';

import './VorTable.css';

function ProfileTable() {
  const Profiles = useFlexionStore((state) => state.Profiles);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const GewDurchbiegung = useFlexionStore((state) => state.GewDurchbiegung);
  const Länge = useFlexionStore((state) => state.Länge);
  const Streckenlast = useFlexionStore((state) => state.Streckenlast);
  const Punktlast = useFlexionStore((state) => state.Punktlast);
  const Slider = useFlexionStore((state) => state.Slider);
  const Radio = useFlexionStore((state) => state.Radio);
  const [text, setText] = useState(getText(Sprache));
  const [DataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setText(getText(Sprache));
  }, [Sprache]);

  const IDs = useMemo(() => {
    const tempIDs = [];
    Profiles.forEach((profile) => {
      if (ProfileTable.NAMES.includes(profile.Description)) {
        tempIDs.push(profile.ID);
      }
    });
    return tempIDs;
  }, [Profiles]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://app.rk-rose-krieger.com/api/flexion/manyProfiles?IDs=${IDs}`)
      .then((response) => {
        setData(response.data);
        setLoading(false);
        setDataFetched(true);
      });
  }, [IDs]);

  function getProfileData(name) {
    return data.find((profile) => profile.Description === name);
  }

  function Calculate(name) {
    const profile = getProfileData(name);
    if (profile === undefined) return 0;

    const GewDurchbiegungNum = Number(parseFloat(GewDurchbiegung).toFixed(1));
    if (Number.isNaN(GewDurchbiegungNum) || GewDurchbiegungNum === 0) {
      return 0;
    }

    if (Radio === 'Einseitig') {
      return calcs.Einseitig(
        Number(parseFloat(profile.Lineargewicht).toFixed(2)),
        Number(parseFloat(Länge).toFixed(2)),
        profile.E,
        Number(parseFloat(profile.Iy).toFixed(2)),
        Number(parseFloat(Streckenlast).toFixed(2)),
        Number(parseFloat(Punktlast).toFixed(2))
      );
    }
    return calcs.Zweisitig(
      Number(parseFloat(profile.Lineargewicht).toFixed(2)),
      Number(parseFloat(Länge).toFixed(2)),
      profile.E,
      Number(parseFloat(profile.Iy).toFixed(2)),
      Number(parseFloat(Streckenlast).toFixed(2)),
      Number(parseFloat(Punktlast).toFixed(2)),
      Number(parseFloat(Slider).toFixed(2))
    );
  }

  function createDataCell(name) {
    let result = Number(Calculate(name).toFixed(1));
    if (result >= 1000) {
      result = Number(result.toFixed());
    }
    const GewDurchbiegungNum = Number(parseFloat(GewDurchbiegung).toFixed(1));
    if (result < GewDurchbiegungNum) {
      return (
        <RCTooltip content={name}>
          <td className='greentd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    if (result === GewDurchbiegungNum && GewDurchbiegungNum !== 0) {
      return (
        <RCTooltip content={name}>
          <td className='yellowtd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    if (result > GewDurchbiegungNum) {
      return (
        <RCTooltip content={name}>
          <td className='redtd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    return (
      <RCTooltip content={name}>
        <td>{result.toString().replace('.', ',')}</td>
      </RCTooltip>
    );
  }

  if (loading) {
    return <CircularProgress size={72} />;
  }
  return (
    <>
      <h3>{text.Tables ? text.Tables.Profile : ' '}</h3>
      <div className='ScrollTable'>
        {/* {!this.state.DataFetched ? <Button outlined onClick={this.fetchIDs} >
        Profile laden</Button> : ""} */}
        <table className='ProfilTabbelle'>
          <colgroup>
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
          </colgroup>
          <tbody>
            <tr>
              <th />
              <th colSpan='2'>30</th>
              <th colSpan='2'>40</th>
              <th colSpan='2'>50</th>
              <th colSpan='2'>60</th>
              <th colSpan='2'>80</th>
              <th>100</th>
              <th>120</th>
              <th>160</th>
              <th>200</th>
              <th>240</th>
              <th>320</th>
            </tr>
            <tr>
              <th />
              <th>L</th>
              {/* <th>H</th> */}
              <th />
              <th>L</th>
              {/* <th>H</th> */}
              <th />
              <th>L</th>
              {/* <th>H</th> */}
              <th />
              <th>L</th>
              {/* <th>H</th> */}
              <th />
              <th>L</th>
              {/* <th>H</th> */}
              <th />
              <th />
              <th />
              <th />
              <th />
              <th />
              <th />
            </tr>
            <tr>
              <td>30</td>
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-30x30') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-30x60') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-30x80') : <td />}
              {DataFetched ? createDataCell('F-30x100') : <td />}
              {DataFetched ? createDataCell('F-30x120') : <td />}
              {DataFetched ? createDataCell('F-30x160') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>40</td>
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-40x40-L') : <td />}
              {DataFetched ? createDataCell('F-40x40') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-40x80-L') : <td />}
              {DataFetched ? createDataCell('F-40x80') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-40x120') : <td />}
              {DataFetched ? createDataCell('F-40x160') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>50</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-50x50-L') : <td />}
              {DataFetched ? createDataCell('F-50x50') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-50x100') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-50x200') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>60</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-60x60-L') : <td />}
              {DataFetched ? createDataCell('F-60x60') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-60x120') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>80</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-80x80-L') : <td />}
              {DataFetched ? createDataCell('F-80x80/2') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-80x120') : <td />}
              {DataFetched ? createDataCell('F-80x160') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>100</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-100x100') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>120</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('F-120x120') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
            </tr>
            <tr>
              <td>80</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('D-80x80') : <td />}
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('D-80x160') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('D-80x240') : <td />}
              <td className='emptytd' />
            </tr>
            <tr>
              <td>160</td>
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              <td className='emptytd' />
              {DataFetched ? createDataCell('D-160x160') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('D-160x240') : <td />}
              {DataFetched ? createDataCell('D-160x320') : <td />}
            </tr>
          </tbody>
        </table>
      </div>
      <p>{text.Tables ? text.Tables.LProfile : ' '}</p>
    </>
  );
}
ProfileTable.NAMES = [
  'F-30x30',
  'F-40x40',
  'F-40x40-L',
  'F-50x50',
  'F-50x50-L',
  'F-30x60',
  'F-30x80',
  'F-30x100',
  'F-30x120',
  'F-30x160',
  'F-40x80-L',
  'F-40x80',
  'F-40x120',
  'F-40x160',
  'F-50x100',
  'F-50x200',
  'F-60x60-L',
  'F-60x60',
  'F-60x120',
  'F-80x80-L',
  'F-80x80/2',
  'F-80x120',
  'F-80x160',
  'F-100x100',
  'F-120x120',
  'D-80x80',
  'D-80x160',
  'D-80x240',
  'D-160x160',
  'D-160x240',
  'D-160x320',
];

export default ProfileTable;
